import type { PlanningTodoAgentItem } from './planning-todo';

/** Parse planning-session agent output into todo items (`[{ title, prompt }]`). */
export function parsePlanningTodoAgentJson(raw: string | null | undefined): PlanningTodoAgentItem[] {
  if (raw == null || raw.trim() === '') return [];
  let text = raw.trim();
  const fence = text.match(/```(?:json)?\s*([\s\S]*?)```/i);
  if (fence?.[1]) text = fence[1].trim();

  let parsed: unknown;
  try {
    parsed = JSON.parse(text) as unknown;
  } catch {
    const start = text.indexOf('[');
    const end = text.lastIndexOf(']');
    if (start < 0 || end <= start) return [];
    try {
      parsed = JSON.parse(text.slice(start, end + 1)) as unknown;
    } catch {
      return [];
    }
  }

  if (!Array.isArray(parsed)) return [];

  const rows: PlanningTodoAgentItem[] = [];
  for (const item of parsed) {
    if (!item || typeof item !== 'object' || Array.isArray(item)) continue;
    const o = item as Record<string, unknown>;
    const title = typeof o.title === 'string' ? o.title.trim() : '';
    const prompt =
      typeof o.prompt === 'string'
        ? o.prompt.trim()
        : typeof o.promptText === 'string'
          ? o.promptText.trim()
          : '';
    if (!title || !prompt) continue;
    rows.push({ title, prompt });
  }
  return rows;
}
